import { call, fork, put, take } from 'redux-saga/effects';
import {Action} from 'redux-actions';
import {enqueueErrorSnackbar} from '../action/snackbarCommands';
import {getI18n} from 'react-i18next';
import Logger from '../common/logger';
import {Api} from '../api';
import {FetchLocationAvailabilitiesPayload, fetchLocationAvailabilities} from '../action/locationsCommands';
import {AssetGroup} from '../api/types';
import {locationAvailabilitiesFetched} from '../action/locationsEvents';

const onFetchLocationAvailabilities = function*(
    locationId: string,
    assetGroupId: string,
    from: Date,
    to: Date,
) {
    try {
        const assetGroup: AssetGroup = yield call(
            Api.fetchLocationAssetGroupAvailabilities,
            assetGroupId,
            from,
            to,
        );
        yield put(locationAvailabilitiesFetched({
            locationId, assetGroup,
        }));

    } catch (e) {
        Logger('Saga').error(e);
        yield put(enqueueErrorSnackbar({
            message: getI18n().t('snackbar.error.start_rental'),
        }));
    }
};

export function* fetchLocationAvailabilitiesFlow() {
    while (true) {
        const action: Action<FetchLocationAvailabilitiesPayload> = yield take(fetchLocationAvailabilities.toString());
        yield fork(onFetchLocationAvailabilities,
            action.payload.locationId,
            action.payload.assetGroupId,
            action.payload.fromDate,
            action.payload.toDate,
        );
    }
}

